import { IAnalyticsStrategy } from '../../analytics';
import { GoogleTagManagerService } from '../googleTagManager/GoogleTagManagerService';

export class WebAnalyticsStrategy implements IAnalyticsStrategy {
  public trackPageView = GoogleTagManagerService.trackVirtualPageView;
  public trackEvent = GoogleTagManagerService.trackEvent;
  public pushUserInfos = GoogleTagManagerService.pushUserInfos;
}
